import React, { useState } from "react";
import NavigationButton from "../../components/ui/atoms/MNavigationButton";
import { IconChevronRight, IconId } from "@tabler/icons-react";
import { MButton } from "@/components/ui/atoms/MButtons";
import { MAccordionHeader } from "@/components/ui/atoms/MAccordionHeader";

const ButtonTest = () => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="p-8 space-y-4 bg-[#F6F6F6] min-h-screen">
      <h2 className="text-xl font-semibold mb-4">MButton Filled Variants</h2>
      <div className="flex flex-row gap-4 mb-8">
        <MButton size="sm" variant="filled">
          Filled SM
        </MButton>
        <MButton size="md" variant="filled">
          Filled MD
        </MButton>
        <MButton size="lg" variant="filled">
          Filled LG
        </MButton>
      </div>
      <h2 className="text-xl font-semibold mb-4">MButton Outline Variants</h2>
      <div className="flex flex-row gap-4 mb-8">
        <MButton size="sm" variant="outline">
          Outline SM
        </MButton>
        <MButton size="md" variant="outline">
          Outline MD
        </MButton>
        <MButton size="lg" variant="outline">
          Outline LG
        </MButton>
      </div>
      <h2 className="text-xl font-semibold mb-4">MButton Link Variants</h2>
      <div className="flex flex-row gap-4 mb-8">
        <MButton size="sm" variant="link">
          Link SM
        </MButton>
        <MButton size="md" variant="link">
          Link MD
        </MButton>
        <MButton size="lg" variant="link">
          Link LG
        </MButton>
      </div>
      <h2 className="text-xl font-semibold mb-4">
        MButton Icon-Only Filled Variants
      </h2>
      <div className="flex flex-row gap-4 mb-8">
        <MButton
          size="sm"
          variant="icon-only-filled"
          icon="Plus"
          aria-label="Add"
        />
        <MButton
          size="md"
          variant="icon-only-filled"
          icon="Plus"
          aria-label="Add"
        />
        <MButton
          size="lg"
          variant="icon-only-filled"
          icon="Plus"
          aria-label="Add"
        />
        <MButton
          size="xl"
          variant="icon-only-filled"
          icon="Plus"
          aria-label="Add"
        />
      </div>
      <h2 className="text-xl font-semibold mb-4">
        MButton Icon-Only Outline Variants
      </h2>
      <div className="flex flex-row gap-4 mb-8">
        <MButton
          size="sm"
          variant="icon-only-outline"
          icon="Plus"
          aria-label="Add"
        />
        <MButton
          size="md"
          variant="icon-only-outline"
          icon="Plus"
          aria-label="Add"
        />
        <MButton
          size="lg"
          variant="icon-only-outline"
          icon="Plus"
          aria-label="Add"
        />
        <MButton
          size="xl"
          variant="icon-only-outline"
          icon="Plus"
          aria-label="Add"
        />
      </div>
      <hr className="my-8" />
      <h2 className="text-xl font-semibold mb-4">
        Disabled Button Variants (using disabled prop)
      </h2>
      <h3 className="text-lg font-semibold mb-2">Filled</h3>
      <div className="flex flex-row gap-4 mb-4">
        <MButton size="sm" variant="filled" disabled>
          Filled SM
        </MButton>
        <MButton size="md" variant="filled" disabled>
          Filled MD
        </MButton>
        <MButton size="lg" variant="filled" disabled>
          Filled LG
        </MButton>
      </div>
      <h3 className="text-lg font-semibold mb-2">Outline</h3>
      <div className="flex flex-row gap-4 mb-4">
        <MButton size="sm" variant="outline" disabled>
          Outline SM
        </MButton>
        <MButton size="md" variant="outline" disabled>
          Outline MD
        </MButton>
        <MButton size="lg" variant="outline" disabled>
          Outline LG
        </MButton>
      </div>
      <h3 className="text-lg font-semibold mb-2">Link</h3>
      <div className="flex flex-row gap-4 mb-4">
        <MButton size="sm" variant="link" disabled>
          Link SM
        </MButton>
        <MButton size="md" variant="link" disabled>
          Link MD
        </MButton>
        <MButton size="lg" variant="link" disabled>
          Link LG
        </MButton>
      </div>
      <h3 className="text-lg font-semibold mb-2">Icon-Only Filled</h3>
      <div className="flex flex-row gap-4 mb-4">
        <MButton
          size="sm"
          variant="icon-only-filled"
          icon="Plus"
          aria-label="Add"
          disabled
        />
        <MButton
          size="md"
          variant="icon-only-filled"
          icon="Plus"
          aria-label="Add"
          disabled
        />
        <MButton
          size="lg"
          variant="icon-only-filled"
          icon="Plus"
          aria-label="Add"
          disabled
        />
        <MButton
          size="xl"
          variant="icon-only-filled"
          icon="Plus"
          aria-label="Add"
          disabled
        />
      </div>
      <h3 className="text-lg font-semibold mb-2">Icon-Only Outline</h3>
      <div className="flex flex-row gap-4 mb-4">
        <MButton
          size="sm"
          variant="icon-only-outline"
          icon="Plus"
          aria-label="Add"
          disabled
        />
        <MButton
          size="md"
          variant="icon-only-outline"
          icon="Plus"
          aria-label="Add"
          disabled
        />
        <MButton
          size="lg"
          variant="icon-only-outline"
          icon="Plus"
          aria-label="Add"
          disabled
        />
        <MButton
          size="xl"
          variant="icon-only-outline"
          icon="Plus"
          aria-label="Add"
          disabled
        />
      </div>
      <hr className="my-4" />
      <h2 className="text-xl font-semibold mb-4">
        Comparison: disabled prop vs state="disabled"
      </h2>
      <div className="flex flex-row gap-4 mb-4">
        <div className="flex flex-col gap-2">
          <span className="text-sm font-medium">
            Using disabled prop (recommended):
          </span>
          <MButton variant="filled" disabled>
            Disabled Button
          </MButton>
        </div>
        <div className="flex flex-col gap-2">
          <span className="text-sm font-medium">
            Using state="disabled" (legacy):
          </span>
          <MButton variant="filled" state="disabled">
            Disabled Button
          </MButton>
        </div>
      </div>
      <hr className="my-8" />
      <h2 className="text-xl font-semibold mb-4">Pressed Button Variants</h2>
      <h3 className="text-lg font-semibold mb-2">Filled</h3>
      <div className="flex flex-row gap-4 mb-4">
        <MButton size="sm" variant="filled" state="pressed">
          Filled SM
        </MButton>
        <MButton size="md" variant="filled" state="pressed">
          Filled MD
        </MButton>
        <MButton size="lg" variant="filled" state="pressed">
          Filled LG
        </MButton>
      </div>
      <h3 className="text-lg font-semibold mb-2">Outline</h3>
      <div className="flex flex-row gap-4 mb-4">
        <MButton size="sm" variant="outline" state="pressed">
          Outline SM
        </MButton>
        <MButton size="md" variant="outline" state="pressed">
          Outline MD
        </MButton>
        <MButton size="lg" variant="outline" state="pressed">
          Outline LG
        </MButton>
      </div>
      <h3 className="text-lg font-semibold mb-2">Link</h3>
      <div className="flex flex-row gap-4 mb-4">
        <MButton size="sm" variant="link" state="pressed">
          Link SM
        </MButton>
        <MButton size="md" variant="link" state="pressed">
          Link MD
        </MButton>
        <MButton size="lg" variant="link" state="pressed">
          Link LG
        </MButton>
      </div>
      <h3 className="text-lg font-semibold mb-2">Icon-Only Filled</h3>
      <div className="flex flex-row gap-4 mb-4">
        <MButton
          size="sm"
          variant="icon-only-filled"
          icon="Plus"
          aria-label="Add"
          state="pressed"
        />
        <MButton
          size="md"
          variant="icon-only-filled"
          icon="Plus"
          aria-label="Add"
          state="pressed"
        />
        <MButton
          size="lg"
          variant="icon-only-filled"
          icon="Plus"
          aria-label="Add"
          state="pressed"
        />
        <MButton
          size="xl"
          variant="icon-only-filled"
          icon="Plus"
          aria-label="Add"
          state="pressed"
        />
      </div>
      <h3 className="text-lg font-semibold mb-2">Icon-Only Outline</h3>
      <div className="flex flex-row gap-4 mb-4">
        <MButton
          size="sm"
          variant="icon-only-outline"
          icon="Plus"
          aria-label="Add"
          state="pressed"
        />
        <MButton
          size="md"
          variant="icon-only-outline"
          icon="Plus"
          aria-label="Add"
          state="pressed"
        />
        <MButton
          size="lg"
          variant="icon-only-outline"
          icon="Plus"
          aria-label="Add"
          state="pressed"
        />
        <MButton
          size="xl"
          variant="icon-only-outline"
          icon="Plus"
          aria-label="Add"
          state="pressed"
        />
      </div>
      <hr className="my-8" />
      <h2 className="text-xl font-semibold mb-4">Back Button</h2>
      <div className="flex flex-col gap-2 mb-4">
        <span className="text-base">With handleClick callback:</span>
        <MButton
          variant="back"
          onClick={() => alert("Back button clicked!")}
        ></MButton>
        <MButton variant="back" onClick={() => alert("Custom back clicked!")}>
          Go Back
        </MButton>
      </div>
      <hr className="my-8" />
      <h2 className="text-xl font-semibold mb-4">Navigation Button Variants</h2>
      <div className="flex flex-row gap-4 mb-4">
        <NavigationButton
          text="Navigational Button"
          leftIcon="id"
          rightIcon="chevron-right"
        />
      </div>

      <hr className="my-8" />
      <h2 className="text-xl font-semibold mb-4">MAccordionHeader</h2>
      <div className="">
        <MAccordionHeader
          title="Click to toggle content"
          isOpen={isOpen}
          onClick={() => setIsOpen(!isOpen)}
        />
        {isOpen && (
          <div className="p-4 mt-2 bg-gray-50 rounded-b">
            This content appears when the header is clicked.
          </div>
        )}
      </div>
    </div>
  );
};

export default ButtonTest;
